"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const foundations_1 = require("@airstudio/foundations");
const actions = require("./actions");
exports.create = (dispatch) => {
    return async (name) => {
        dispatch(actions.createRequest(name));
        try {
            const { data } = await foundations_1.Api.client.post('/workspaces', { item: { name } });
            dispatch(actions.createSuccess(data));
        }
        catch (error) {
            dispatch(actions.createFailure(foundations_1.Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.update = (dispatch) => {
    return async (workspaceId, attributes) => {
        dispatch(actions.updateRequest(workspaceId, attributes));
        try {
            const { data } = await foundations_1.Api.client.put(`/workspaces/${workspaceId}`, { item: attributes });
            dispatch(actions.updateSuccess(workspaceId, data));
        }
        catch (error) {
            dispatch(actions.updateFailure(foundations_1.Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
exports.switchActive = (dispatch) => {
    return async (workspaceId) => {
        dispatch(actions.switchActive(workspaceId));
        foundations_1.Api.setUpWorkspace(workspaceId);
        return true;
    };
};
//# sourceMappingURL=operations.js.map